import { render, staticRenderFns } from "./age.vue?vue&type=template&id=7ec5acbb&scoped=true"
import script from "./age.vue?vue&type=script&lang=js"
export * from "./age.vue?vue&type=script&lang=js"
import style0 from "./age.vue?vue&type=style&index=0&id=7ec5acbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec5acbb",
  null
  
)

export default component.exports